var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 19,
    viewBox: "0 0 17 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6498 0C11.5385 0.0636495 10.2628 0.673871 9.50426 1.45097C8.81901 2.15776 8.27835 3.20747 8.49906 4.22301C9.70669 4.25436 10.9188 3.62833 11.6446 2.83699C12.3221 2.09695 12.8358 1.06399 12.6498 0ZM12.7156 4.22116C10.9721 4.22116 10.2432 5.27691 9.03554 5.27691C7.79322 5.27691 6.65754 4.28796 5.15403 4.28796C3.10886 4.28891 0 6.15627 0 10.5557C0 14.558 3.67942 18.9999 5.75639 18.9999C7.018 19.0122 7.32385 18.218 9.03554 18.2094C10.7492 18.1971 11.1189 19.0103 12.3825 18.9999C13.805 18.9894 14.916 17.4485 15.7275 16.2278C16.3096 15.3538 16.5489 14.9076 17 13.9196C13.6528 13.0836 12.9868 7.76303 17 6.66294C16.2425 5.389 14.0312 4.22116 12.7156 4.22116Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.85770339f8240a9b083c852d2f9f5011.svg";
export { ForwardRef as ReactComponent };